var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useMemo, useReducer, useRef, } from "react";
import { callAPI } from "../../lib/common";
import { useAuth } from "./AuthProvider";
import { sortSubjectPictures, suspendResource } from "../../utils";
import HasPicturesInPipelineDialog from "../Components/HasPicturesInPipelineDialog";
import { useWebshopApiClient } from "@/react/Webshop/providers/WebshopApiClientProvider";
export const PictureSetsContext = React.createContext(null);
export const ACTION_SET_PICTURE_SETS = "setPictureSets";
export const ACTION_START_LOADING = "startLoading";
export const ACTION_STOP_LOADING = "stopLoading";
export const ACTION_SET_CURRENT_PICTURE_SET = "setCurrentPictureSet";
const ACTION_TOGGLE_FAVORITE_START = "TogglingFavoriteStart";
const ACTION_TOGGLE_FAVORITE_SUCCESS = "toggleFavoriteSuccess";
const ACTION_TOGGLE_FAVORITE_FAILURE = "toggleFavoriteFailure";
const ACTION_SET_USER_SUBJECT_FAVORITE_UUIDS = "setUserSubjectFavoriteUUIDs";
const ACTION_SET_YEAR_BOOK_POSE = "setYearBookPose";
function updatePicture(pictureSets, pictureSetUuid, pictureUuid, updater) {
    return pictureSets.map((ps) => {
        if (ps.subject.uuid !== pictureSetUuid) {
            return ps;
        }
        return Object.assign(Object.assign({}, ps), { pictures: sortSubjectPictures(ps.pictures.map((pic) => {
                if (pic.uuid !== pictureUuid) {
                    return pic;
                }
                return updater(pic);
            })) });
    });
}
const pictureSetsReducer = (state, action) => {
    var _a, _b, _c;
    switch (action.type) {
        case ACTION_SET_PICTURE_SETS:
            return Object.assign(Object.assign({}, state), { isLoading: false, pictureSets: action.data ? sortPictureSets(action.data) : null });
        case ACTION_START_LOADING:
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case ACTION_STOP_LOADING:
            return Object.assign(Object.assign({}, state), { isLoading: false });
        case ACTION_SET_CURRENT_PICTURE_SET:
            // Fire and forget, let the server get the current:
            if (!action.pictureSet) {
                return state;
            }
            console.log("Setting current picture set in action");
            return Object.assign(Object.assign({}, state), { pictureSets: (state.pictureSets &&
                    state.pictureSets.map((ps) => {
                        var _a;
                        console.log("Mapping picture sets");
                        if (ps.subject.uuid == ((_a = action.pictureSet) === null || _a === void 0 ? void 0 : _a.subject.uuid)) {
                            return Object.assign(Object.assign({}, ps), { isCurrent: true });
                        }
                        else if (ps.isCurrent) {
                            return Object.assign(Object.assign({}, ps), { isCurrent: false });
                        }
                        return ps;
                    })) ||
                    null });
        case ACTION_TOGGLE_FAVORITE_START: {
            const { pictureSetUuid, pictureUuid } = action.payload;
            return Object.assign(Object.assign({}, state), { pictureSets: updatePicture((_a = state.pictureSets) !== null && _a !== void 0 ? _a : [], pictureSetUuid, pictureUuid, (pic) => (Object.assign(Object.assign({}, pic), { isSaving: true, 
                    // clear previous errors
                    error: undefined }))) });
        }
        case ACTION_TOGGLE_FAVORITE_SUCCESS: {
            const { pictureSetUuid, pictureUuid, status } = action.payload;
            return Object.assign(Object.assign({}, state), { pictureSets: updatePicture((_b = state.pictureSets) !== null && _b !== void 0 ? _b : [], pictureSetUuid, pictureUuid, (pic) => (Object.assign(Object.assign({}, pic), { isSaving: false, isUserFavorite: status === "added" }))) });
        }
        case ACTION_TOGGLE_FAVORITE_FAILURE: {
            const { pictureSetUuid, pictureUuid } = action.payload;
            return Object.assign(Object.assign({}, state), { pictureSets: updatePicture((_c = state.pictureSets) !== null && _c !== void 0 ? _c : [], pictureSetUuid, pictureUuid, (pic) => (Object.assign(Object.assign({}, pic), { isSaving: false, error: action.error }))) });
        }
        case ACTION_SET_USER_SUBJECT_FAVORITE_UUIDS: {
            const { pictureSetUuid, pictureUuids } = action.payload;
            return Object.assign(Object.assign({}, state), { pictureSets: (state.pictureSets || []).map((pictureSet) => {
                    if (pictureSet.subject.uuid != pictureSetUuid) {
                        console.log("Update favorites, skipping picture set", pictureSetUuid, pictureSet.subject.uuid);
                        return pictureSet;
                    }
                    console.log("Update favorites, doing picture set");
                    return Object.assign(Object.assign({}, pictureSet), { pictures: pictureSet.pictures.map((picture) => {
                            console.log("Update picture favorite status", picture.uuid, pictureUuids);
                            return Object.assign(Object.assign({}, picture), { isUserFavorite: pictureUuids.indexOf(picture.uuid) >= 0 });
                        }) });
                }) });
        }
        case ACTION_SET_YEAR_BOOK_POSE: {
            const { pictureSetUuid, pictureClientRef, jobYearbookPoseUuid } = action.payload;
            return Object.assign(Object.assign({}, state), { pictureSets: (state.pictureSets || []).map((pictureSet) => {
                    var _a;
                    if (pictureSet.subject.uuid != pictureSetUuid) {
                        return pictureSet;
                    }
                    const yearbookPoses = (_a = pictureSet.yearbookPoses) !== null && _a !== void 0 ? _a : [];
                    let yearbookPose = yearbookPoses.find((ybp) => ybp.jobYearbookPoseUuid === jobYearbookPoseUuid);
                    if (!yearbookPose) {
                        yearbookPose = {
                            pictureClientRef,
                            jobYearbookPoseUuid,
                        };
                        yearbookPoses.push(yearbookPose);
                    }
                    return Object.assign(Object.assign({}, pictureSet), { yearbookPoses: yearbookPoses.map((yearbookPose) => {
                            if (yearbookPose.jobYearbookPoseUuid === jobYearbookPoseUuid) {
                                return Object.assign(Object.assign({}, yearbookPose), { pictureClientRef });
                            }
                            return yearbookPose;
                        }) });
                }) });
        }
        default:
            return state;
    }
};
const sortPictureSets = (pictureSets) => {
    return pictureSets.map((pictureSet) => {
        return Object.assign(Object.assign({}, pictureSet), { pictures: sortSubjectPictures(pictureSet.pictures) });
    });
};
// FIXME: Superhack to get suspense to work by placing code outside the component
let pictureSetsResource = null;
function getPictureSetsSuspendResource(webshopApiClient) {
    if (!pictureSetsResource) {
        pictureSetsResource = suspendResource(webshopApiClient.getPictureSets());
    }
    return pictureSetsResource;
}
const PictureSetsProvider = ({ children, }) => {
    console.log("Rendering picture sets");
    const webshopApiClient = useWebshopApiClient();
    const { isAuthenticated } = useAuth();
    const isInitialRender = useRef(true);
    let initialPictureSets = null;
    if (isInitialRender.current && isAuthenticated) {
        isInitialRender.current = false;
        const pictureSetsSuspendResource = getPictureSetsSuspendResource(webshopApiClient);
        // This read will throw and exception if data not loaded, then
        // suspense will recreate the component
        initialPictureSets = pictureSetsSuspendResource.read();
    }
    const [state, dispatch] = useReducer(pictureSetsReducer, {
        isLoading: false,
        pictureSets: initialPictureSets !== null
            ? "user_error" in initialPictureSets
                ? null
                : sortPictureSets(initialPictureSets)
            : null,
    });
    console.log("Rendering picture sets provider", isAuthenticated, state);
    const update = () => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: ACTION_START_LOADING,
            });
            webshopApiClient
                .getPictureSets()
                .then((pictureSets) => {
                console.log("Debug Picture sets", pictureSets);
                if ("user_error" in pictureSets) {
                    pictureSets = [];
                }
                // Sto before setting picture sets, in case we depend on loading:
                dispatch({
                    type: ACTION_SET_PICTURE_SETS,
                    data: pictureSets,
                });
                resolve(pictureSets);
            })
                .catch(() => {
                dispatch({
                    type: ACTION_STOP_LOADING,
                });
            });
        });
    };
    useEffect(() => {
        console.log("Auth changed", isAuthenticated, state.isLoading, state.pictureSets, isAuthenticated && !state.isLoading && state.pictureSets === null);
        // We need to load picture sets:
        if (isAuthenticated && !state.isLoading && state.pictureSets === null) {
            console.log("Rendering picture sets need update");
            update();
        }
        else if (!isAuthenticated) {
            console.log("Rendering picture sets need auth");
            dispatch({
                type: ACTION_SET_PICTURE_SETS,
                data: null,
            });
        }
    }, [isAuthenticated]);
    const setCurrentPictureSet = useCallback((pictureSet) => {
        console.log("Setting current picture set");
        callAPI("/ajax/prophoto/set_current_subject.php?uuid=" + pictureSet.subject.uuid).then((status) => {
            // Let's just ignore it for now if it failed
            if (status.error) {
                return;
            }
            dispatch({
                type: ACTION_SET_CURRENT_PICTURE_SET,
                pictureSet: pictureSet,
            });
        });
    }, []);
    const showSetNameDialog = useMemo(() => {
        const currentPictureSet = state.pictureSets !== null
            ? state.pictureSets.find((ps) => ps.isCurrent)
            : null;
        console.log("SSD: Should show dialog?", currentPictureSet, currentPictureSet === null || currentPictureSet === void 0 ? void 0 : currentPictureSet.subject.name);
        if (!currentPictureSet) {
            return false;
        }
        // If it's an autogenerated subject, the name is only numbers:
        if (currentPictureSet.subject.name.match(/^\d{4}$/)) {
            console.log("SSD: Name matches digital regexp");
            return true;
        }
        console.log("SSD: No set name dialog");
        return false;
    }, [state.pictureSets]);
    const getPictureByUuid = (uuid) => {
        var _a;
        for (const pictureSet of (_a = state.pictureSets) !== null && _a !== void 0 ? _a : []) {
            for (const picture of pictureSet.pictures) {
                if (picture.uuid === uuid) {
                    return picture;
                }
            }
        }
        return null;
    };
    const toggleUserFavoritePicture = (pictureSetUuid, pictureUuid, userUuid) => __awaiter(void 0, void 0, void 0, function* () {
        // Indicate toggle in progress
        dispatch({
            type: ACTION_TOGGLE_FAVORITE_START,
            payload: {
                pictureSetUuid,
                pictureUuid,
            },
        });
        try {
            // Perform the API request to toggle favorite
            const response = yield fetch(`/api/webshop/user/picture-sets/${pictureSetUuid}/pictures/${pictureUuid}/toggle-favorite`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(Object.assign({ subject_uuid: pictureSetUuid, picture_uuid: pictureUuid }, (userUuid && { user_uuid: userUuid }))),
            });
            const data = yield response.json();
            if (!response.ok) {
                // On error, dispatch failure with error message
                throw new Error(data.error || "Failed to toggle favorite");
            }
            // On success, update the toggle state in the store
            dispatch({
                type: ACTION_TOGGLE_FAVORITE_SUCCESS,
                payload: {
                    pictureSetUuid,
                    pictureUuid,
                    status: data.status, // 'added' or 'removed'
                },
            });
        }
        catch (error) {
            // Dispatch failure action and optionally log or show error
            dispatch({
                type: ACTION_TOGGLE_FAVORITE_FAILURE,
                payload: {
                    pictureSetUuid,
                    pictureUuid,
                },
                error,
            });
        }
    });
    const setYearbookPose = (pictureSetUuid, pictureClientRef, jobYearbookPoseUuid) => {
        dispatch({
            type: ACTION_SET_YEAR_BOOK_POSE,
            payload: {
                pictureSetUuid,
                pictureClientRef,
                jobYearbookPoseUuid,
            },
        });
    };
    const setUserFavoritesPictureUuids = (pictureSetUuid, pictureUuids) => {
        dispatch({
            type: ACTION_SET_USER_SUBJECT_FAVORITE_UUIDS,
            payload: {
                pictureSetUuid,
                pictureUuids,
            },
        });
    };
    const currentPictureSet = state.pictureSets !== null
        ? state.pictureSets.find((ps) => ps.isCurrent)
        : null;
    // Report the subject's experiment arms to analytics, keyed on the serialised
    // arms so a re-fetch of the same assignment does not re-send it.
    const experimentArms = currentPictureSet === null || currentPictureSet === void 0 ? void 0 : currentPictureSet.experimentArms;
    const experimentArmsKey = experimentArms
        ? JSON.stringify(experimentArms)
        : null;
    useEffect(() => {
        if (!experimentArms) {
            return;
        }
        if (window.isEpmsAnalyticsFeatureEnabled && window.epmsAnalytics) {
            window.epmsAnalytics.setExperimentArms(experimentArms);
        }
    }, [experimentArmsKey]);
    const ret = {
        isLoaded: !state.isLoading && state.pictureSets !== null,
        pictureSets: state.pictureSets,
        update,
        currentPictureSet,
        setCurrentPictureSet,
        showSetNameDialog,
        setUserFavoritesPictureUuids,
        toggleUserFavoritePicture,
        setYearbookPose,
        getPictureByUuid,
    };
    console.log("Picture Sets state", ret);
    return (React.createElement(PictureSetsContext.Provider, { value: ret },
        children,
        React.createElement(HasPicturesInPipelineDialog, null)));
};
export default PictureSetsProvider;
